import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssetCount = async (): Promise<number> => {
  const response = await axios.get<number>(
    `${API_BASE_URL}/GetDigitalAssetsCount/`,
  );
  return response.data;
};
